function check(rgb, el)
{
	if (rgb == 1)
	{
		if (/\D+/.test(el.value)) el.value = el.value.replace(/\D+/g, "");
		if (el.value > 255) el.value = 255;
		if (el.value.length > 0) convert(1)
	}
	else
	{
		if (/[^A-Fa-f0-9]+/.test(el.value)) el.value = el.value.replace(/[^A-Fa-f0-9]+/g, "");
		if (el.value.length == 3 || el.value.length == 6)
		{
			el.value = el.value.toUpperCase();
			convert(0)
		}
	}
}

function convert(rgb)
{
	hex = document.getElementById("hex");
	rgb1 = document.getElementById("rgb1");
	rgb2 = document.getElementById("rgb2");
	rgb3 = document.getElementById("rgb3");
	hexprev = document.getElementById("hex-prev");
	rgbprev = document.getElementById("rgb-prev");
	if (rgb == 1)
	{
		out = rgbtohex(Math.floor(rgb1.value / 16)) + rgbtohex(rgb1.value % 16);
		out += rgbtohex(Math.floor(rgb2.value / 16)) + rgbtohex(rgb2.value % 16);
		out += rgbtohex(Math.floor(rgb3.value / 16)) + rgbtohex(rgb3.value % 16);
		writeToDocument(1, out)
	}
	else if (hex.value.length == 3)
	{
		outR = hextorgb(hex.value[0]) *
			16 + hextorgb(hex.value[0]);
		outG = hextorgb(hex.value[1]) * 16 + hextorgb(hex.value[1]);
		outB = hextorgb(hex.value[2]) * 16 + hextorgb(hex.value[2]);
		writeToDocument(0, outR, outG, outB)
	}
	else
	{
		outR = hextorgb(hex.value[0]) * 16 + hextorgb(hex.value[1]);
		outG = hextorgb(hex.value[2]) * 16 + hextorgb(hex.value[3]);
		outB = hextorgb(hex.value[4]) * 16 + hextorgb(hex.value[5]);
		writeToDocument(0, outR, outG, outB)
	}
}

function writeToDocument(rgb, value1, value2, value3)
{
	if (rgb == 1)
	{
		hex.value = value1;
		hexprev.innerHTML = "#" + value1;
		hexprev.style.background = "#" + value1;
		rgbprev.innerHTML = "rgb(" + rgb1.value + ", " + rgb2.value + ", " + rgb3.value + ")";
		rgbprev.style.background = "#" + value1
	}
	else
	{
		rgb1.value = value1;
		rgb2.value = value2;
		rgb3.value = value3;
		hexprev.innerHTML = "#" + hex.value;
		hexprev.style.background = "#" + hex.value;
		rgbprev.innerHTML = "rgb(" + value1 + ", " + value2 + ", " + value3 + ")";
		rgbprev.style.background = "#" + hex.value
	}
}

function hextorgb(value)
{
	if (parseInt(value) == value && value >= 0 && value <= 9) return parseInt(value);
	switch (value)
	{
		case "A":
			return 10;
			break;
		case "B":
			return 11;
			break;
		case "C":
			return 12;
			break;
		case "D":
			return 13;
			break;
		case "E":
			return 14;
			break;
		case "F":
			return 15;
			break;
		default:
			return false
	}
}

function rgbtohex(value)
{
	if (parseInt(value) == value)
	{
		value = parseInt(value);
		if (value >= 0 && value <= 9) return value.toString();
		switch (value)
		{
			case 10:
				return "A";
				break;
			case 11:
				return "B";
				break;
			case 12:
				return "C";
				break;
			case 13:
				return "D";
				break;
			case 14:
				return "E";
				break;
			case 15:
				return "F";
				break;
			default:
				return false
		}
	}
};
